<template>
    <div class="col-sm-12 nopads">
        <div class="col-sm-12 editor-form d-flex flex-column" style="height: 85vh; overflow-y: hidden !important;">
            <header class="flex-shrink-0 border-bottom">
                <h2 class="editor-header p-1">{{ inspectionUpdate.id > 0 ? $t('inspection_editor.edit_inspection') : $t('inspection_editor.add_inspection')}}</h2>
            </header>
            <main class="flex-grow-1 px-2" style="overflow-y: auto; overflow-x: hidden">
            <h4 class="form-header pl-3 pr-4">{{ $t('contracts.basic_info')}}</h4>
            <div class="col-sm-12">
                <span class="span-title">{{ $t('inspectable_editor.name') }}</span>
                <input
                    id="name"
                    v-model="inspectionUpdate.name"
                    type="text"
                    class="form-control form-control-sm"
                />
                <span class="span-title">{{ $t('inspection_editor.inspection_type') }}</span>
                <select
                    id="type"
                    v-model="inspectionUpdate.type"
                    class="form-select form-select-sm"
                >
                    <option
                        v-for="type in types"
                        :key="type.value"
                        :value="type.value"
                    >
                        {{ type.text }}
                    </option>
                </select>
                <div v-if="inspectionUpdate.type === VEHICLE" class="nopads">
                    <span class="span-title">{{ $t('inspection_editor.vehicle_type') }}</span>
                    <select
                        id="vehicle_type"
                        v-model="inspectionUpdate.vehicle_type"
                        class="form-select form-select-sm"
                    >
                        <option
                            v-for="type in vehicle_types"
                            :key="type.value"
                            :value="type.value"
                        >
                            {{ type.text }}
                        </option>
                    </select>
                </div>
                <span class="span-title">{{ $t('inspection_editor.inspection_frequency') }}</span>
                <select
                    id="inspection_freq"
                    v-model="inspectionUpdate.frequency"
                    class="form-select form-select-sm"
                >
                    <option
                        v-for="freq in inspection_frequencies"
                        :key="freq.value"
                        :value="freq.value"
                    >
                        {{ freq.text }}
                    </option>
                </select>
                <div class="row">
                    <div class="col-md-6">
                        <span class="span-title">
                            {{ $t('inspection_editor.mandatory') }}
                        </span>
                        <div class="form-check form-switch">
                            <input
                                id="in_use"
                                v-model="inspectionUpdate.mandatory"
                                class="form-check-input"
                                type="checkbox"
                            >
                        </div>
                        <Transition name="fade">
                            <div v-if="inspectionUpdate.mandatory" class="info-box mt-4 col-12">
                                <i class="bi bi-info-circle me-2" />
                                <span>{{ $t("inspection_editor.mandatory_tip") }}</span>
                            </div>
                        </Transition>
                    </div>
                    <div class="col-md-6">
                        <span class="span-title">{{ $t('inspection_editor.inactive') }}</span>
                        <div class="form-check form-switch">
                            <input
                                type="checkbox"
                                id="in_active"
                                v-model="inspectionUpdate.in_active"
                                class="form-check-input"
                            />
                        </div>
                    </div>
                </div>
                <hr/>
                <h4 class="form-header pl-3 pr-4">{{ $t('inspection_template.inspectables')}}</h4>
                <div v-if="inspectionUpdate.inspectables.length > 0">
                    <draggable
                        class="list-group"
                        tag="ul"
                        :list="inspectionUpdate.inspectables"
                        v-bind="dragOptions"
                    >
                        <transition-group type="transition" name="flip-list">
                            <li
                                style="list-style: none"
                                v-for="element in inspectionUpdate.inspectables"
                                :key="element.id"
                            >
                                <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                                   @click="element.fixed = !element.fixed"
                                   aria-hidden="true"
                                ></i>
                                <div class="d-flex justify-content-between align-items-center inspectables-ordered">
                                    <span class="flex-grow-1">{{ element.name }}</span>
                                    <button class="btn btn-danger btn-sm" @click="updateInspectablesSelection(element)">
                                        <i class="fa fa-times"/>
                                    </button>
                                </div>
                            </li>
                        </transition-group>
                    </draggable>
                </div>
                <div v-else class="col-sm-12 small-pad">
                    <span>{{ $t('inspection_editor.no_selected_inspectables') }}</span>
                </div>
                <hr/>
                <span
                    v-if="inspectionUpdate.inspectables.length !==inspectables.length"
                    class="span-title"
                >
                    {{ $t('inspection_editor.select_inspectables') }}
                </span>
                <div class="row inspectable-container nopads px-2 mb-3">
                    <div
                        v-for="item in inspectables"
                        :key="item.id"
                        class="col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables nopads"
                        :class="{ 'inspectables-disabled' : isSelected(item.id) }"
                        @click="updateInspectablesSelection(item)"
                    >
                            {{ item.name }}
                    </div>
                </div>

                </div>
            </main>
            <footer class="flex-shrink-0 border-top">
                <div class="col-sm-12 d-flex justify-content-end py-2">
                    <button
                        class="btn btn-sm btn-secondary form-button"
                        @click.stop="cancelEdit"
                    >
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        v-if="inspectionUpdate.id > 0"
                        class="btn btn-sm btn-primary form-button"
                        :disabled="loading"
                        @click.stop="copyInspection"
                    >
                        {{ $t('common.copy') }}
                    </button>
                    <button class="btn btn-sm btn-success form-button" :disabled="loading" @click.stop="submitInspection">
                        {{ $t('common.save') }}
                    </button>
                </div>
            </footer>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />

        <!-- Discard draft confirmation -->
        <base-modal
            v-if="discardConfirmation"
            :hide-header="true"
            :hide-footer="true"
            :no-top-padding="true"
            :allow-overflow="true"
            @ok="confirmDiscard">
            <div class="col-sm-12 nopads">
                <h2 class="editor-header">{{ $t('inspection_editor.discard_draft') }}</h2>
                <span class="pb-2">{{ $t('inspection_editor.discard_draft_confirm') }}</span>
            </div>
            <div class="col-12 button-container">
                <button class="btn btn-sm btn-secondary form-button" @click="cancelDiscard">
                    {{ $t('common.no') }}
                </button>
                <button class="btn btn-sm btn-success form-button" @click="confirmDiscard">
                    {{ $t('common.yes') }}
                </button>
            </div>
        </base-modal>
    </div>
</template>

<script>
import { VueDraggableNext } from 'vue-draggable-next'
import {restApi} from '../mixins/RestApiMixin'
import {inspectionHelper} from '../mixins/InspectionMixin'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'InspectionEditor',
    mixins: [inspectionHelper, restApi],
    components: { draggable: VueDraggableNext, BaseModal},
    props: {
        inspection: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            VEHICLE: 1,
            WORK: 2,
            loading: false,
            inspectables: [],
            inspectionUpdate: this.jsonToInspection(this.inspection),
            isDraftFromCopy: false,
            discardConfirmation: false,
            types: [
                {value: 1, text: this.$t('inspection_template.type.vehicle')},
                {value: 2, text: this.$t('inspection_template.type.work')},
                {value: 4, text: this.$t('inspection_template.type.company')},
                {value: 5, text: this.$t('inspection_template.type.bridge')},
                {value: 6, text: this.$t('inspection_template.type.culvert')},
                {value: 8, text: this.$t('inspection_template.type.user')}
            ],
            vehicle_types: [
                {value: 1, text: this.$t('vehicle_list.vehicle_type.passenger_or_van')},
                {value: 2, text: this.$t('vehicle_list.vehicle_type.truck')},
                {value: 3, text: this.$t('vehicle_list.vehicle_type.trailer')},
                {value: 4, text: this.$t('vehicle_list.vehicle_type.trailer1')},
                {value: 5, text: this.$t('vehicle_list.vehicle_type.loader')},
                {value: 6, text: this.$t('vehicle_list.vehicle_type.tractor')},
                {value: 11, text: this.$t('vehicle_list.vehicle_type.snowplow')},
                {value: 7, text: this.$t('vehicle_list.vehicle_type.spreader')},
                {value: 8, text: this.$t('vehicle_list.vehicle_type.harvester')},
                {value: 9, text: this.$t('vehicle_list.vehicle_type.forwarder')},
                {value: 12, text: this.$t('vehicle_list.vehicle_type.helicopter')},
                {value: 13, text: this.$t('vehicle_list.vehicle_type.paver')},
                {value: 14, text: this.$t('vehicle_list.vehicle_type.road_fence')},
                {value: 15, text: this.$t('vehicle_list.vehicle_type.shock_absorber')},
                {value: 16, text: this.$t('vehicle_list.vehicle_type.digger')},
                {value: 10, text: this.$t('vehicle_list.vehicle_type.other')}
            ],
            inspection_frequencies: [
                {value: 1, text: this.$t('inspection_template.frequency.weekly')},
                {value: 2, text: this.$t('inspection_template.frequency.monthly')},
                {value: 3, text: this.$t('inspection_template.frequency.annually')},
                {value: 4, text: this.$t('inspection_template.frequency.deployment')},
                {value: 5, text: this.$t('inspection_template.frequency.daily')},
                {value: 7, text: this.$t('inspection_template.frequency.once')},
                {value: 6, text: this.$t('inspection_template.frequency.other')}
            ]
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    watch: {
        company: function () {
            this.fetchInspectables()
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost',
            }
        },
    },
    mounted: function () {
        this.fetchInspectables()
    },
    methods: {
        fetchInspectables: function () {
            this.loading = true
            this.restFetch(this.inspectableUrl, this.handleResult)
        },

        updateInspectablesSelection: function (inspectable) {
            var index = this.indexOfInspectable(inspectable.id)
            if (index < 0) {
                this.inspectionUpdate.inspectables.push(inspectable)
            } else {
                this.inspectionUpdate.inspectables.splice(index, 1)
            }
        },

        indexOfInspectable: function (id) {
            return this.inspectionUpdate.inspectables.findIndex(function (obj) {
                return obj.id === id
            })
        },

        isSelected: function (id) {
            var index = this.indexOfInspectable(id)
            return index >= 0
        },

        handleResult: function (response) {
            this.inspectables = response.data
            this.loading = false
        },

        checkValues: function (inspection) {
            if (inspection.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            if (inspection.type === this.VEHICLE && inspection.vehicle_type === '') {
                this.showAlert(this.$t('inspection_editor.invalid_vehicle_type'))
                return undefined
            }
            if (inspection.type === '') {
                this.showAlert(this.$t('inspection_editor.invalid_inspection_type'))
                return undefined
            }
            if (!inspection.frequency || inspection.frequency === '') {
                this.showAlert(this.$t('inspection_editor.invalid_frequency'))
                return undefined
            }
            if (!inspection.inspectables.length) {
                this.showAlert(this.$t('inspection_editor.invalid_inspectables'))
                return undefined
            }
            return inspection
        },

        submitInspection: function () {
            var jsonInspectable = this.checkValues(this.inspectionUpdate)
            if (jsonInspectable !== undefined) {
                this.loading = true
                if (this.inspectionUpdate.id < 1) {
                    this.restAdd(this.inspectionTemplateUrl, jsonInspectable, this.success, this.fail)
                } else {
                    this.restUpdate(this.inspectionTemplateUrl, jsonInspectable, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.loading = false
            this.isDraftFromCopy = false
            this.$emit('closeAndUpdate')
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        copyInspection: function () {
            const draft = this.jsonToInspection(this.inspectionUpdate)
            draft.id = -1
            draft.name = draft.name + ' (' + this.$t('inspection_editor.copy_name_suffix') + ')'
            this.inspectionUpdate = draft
            this.isDraftFromCopy = true
        },

        cancelEdit: function () {
            if (this.inspectionUpdate.id <= 0 && this.isDraftFromCopy) {
                this.discardConfirmation = true
            } else {
                this.$emit('close')
            }
        },

        confirmDiscard: function () {
            this.discardConfirmation = false
            this.$emit('close')
        },

        cancelDiscard: function () {
            this.discardConfirmation = false
        }

    }
}
</script>
<style scoped>
.button {
    margin-top: 35px;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}

.btn {
    @apply font-bold py-2 px-4 rounded;
}

</style>
